/**
 * PDP Feature Showcase - Video and Interaction Handler
 * Enhanced version of pdp-color-image with improved functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  // Initialize PDP Feature Showcase functionality
  initFeatureShowcase();
});

function initFeatureShowcase() {
  const section = document.querySelector('.pdp-feature-showcase-section');
  if (!section) return;

  console.log('PDP Feature Showcase: Initializing...');

  // Initialize video handling
  initVideoHandling();

  // Initialize intersection observer for animations
  initIntersectionObserver();

  // Initialize responsive behavior
  initResponsiveBehavior();

  console.log('PDP Feature Showcase: Initialized successfully');
}

/**
 * Handle video loading and playback optimization
 */
function initVideoHandling() {
  const videos = document.querySelectorAll('.pdp-feature-video');
  
  videos.forEach((video, index) => {
    console.log(`Feature Showcase Video ${index + 1}:`, video.currentSrc || 'No source');

    // Optimize video loading
    video.addEventListener('loadstart', function() {
      console.log(`Feature Showcase Video ${index + 1} load start:`, this.currentSrc);
    });

    video.addEventListener('canplay', function() {
      console.log(`Feature Showcase Video ${index + 1} can play:`, this.currentSrc);
    });

    video.addEventListener('error', function() {
      console.error(`Feature Showcase Video ${index + 1} error:`, this.error);
      handleVideoError(this, index);
    });

    // Ensure video plays when ready
    video.addEventListener('loadedmetadata', function() {
      this.play().catch(e => {
        console.log('Feature Showcase Video autoplay prevented:', e);
      });
    });

    // Loop video seamlessly
    video.addEventListener('ended', function() {
      this.currentTime = 0;
      this.play().catch(e => {
        console.log('Feature Showcase Video loop prevented:', e);
      });
    });

    // Pause/play based on visibility
    video.addEventListener('pause', function() {
      console.log(`Feature Showcase Video ${index + 1} paused`);
    });

    video.addEventListener('play', function() {
      console.log(`Feature Showcase Video ${index + 1} playing`);
    });
  });
}

/**
 * Intersection Observer for animations and performance
 */
function initIntersectionObserver() {
  if (!('IntersectionObserver' in window)) return;

  const section = document.querySelector('.pdp-feature-showcase-section');
  if (!section) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Section is visible, ensure videos play
        const videos = entry.target.querySelectorAll('.pdp-feature-video');
        videos.forEach(video => {
          video.muted = true; // Ensure muted for autoplay
          if (video.paused) {
            video.play().catch(e => {
              console.log('Feature Showcase Video autoplay prevented:', e);
            });
          }
        });

        // Add animation class
        entry.target.classList.add('animate-in');
      } else {
        // Section is not visible, pause videos to save resources
        const videos = entry.target.querySelectorAll('.pdp-feature-video');
        videos.forEach(video => {
          if (!video.paused) {
            video.pause();
          }
        });
      }
    });
  }, {
    threshold: 0.3, // Trigger when 30% of section is visible
    rootMargin: '50px' // Start loading 50px before entering viewport
  });

  observer.observe(section);
}

/**
 * Handle responsive behavior
 */
function initResponsiveBehavior() {
  const container = document.querySelector('.feature-showcase-container');
  if (!container) return;

  function handleResize() {
    const isMobile = window.innerWidth <= 749;
    const isTablet = window.innerWidth > 749 && window.innerWidth <= 1200;
    
    // Adjust video quality based on screen size
    const videos = document.querySelectorAll('.pdp-feature-video');
    videos.forEach(video => {
      if (isMobile) {
        video.style.height = '300px';
      } else if (isTablet) {
        video.style.height = '400px';
      } else {
        video.style.height = '500px';
      }
    });
  }

  // Initial call
  handleResize();

  // Listen for resize events
  window.addEventListener('resize', debounce(handleResize, 250));
}

/**
 * Enhanced error handling for videos
 */
function handleVideoError(video, index) {
  console.error(`Feature Showcase Video ${index + 1} failed to load`);
  
  const container = video.closest('.feature-media-wrapper');
  if (container) {
    // Create fallback content
    const fallback = document.createElement('div');
    fallback.className = 'video-fallback';
    fallback.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #f5f5f5;
      color: #999;
      font-size: 16px;
      text-align: center;
      font-family: "Familjen Grotesk", sans-serif;
    `;
    fallback.innerHTML = `
      <div>
        <div style="font-size: 48px; margin-bottom: 16px;">📷</div>
        <div>Media content unavailable</div>
      </div>
    `;
    
    video.style.display = 'none';
    container.appendChild(fallback);
  }
}

/**
 * Debounce utility function
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Utility function to check if device supports touch
 */
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

/**
 * Initialize scroll-triggered animations
 */
function initScrollAnimations() {
  const elements = document.querySelectorAll('.feature-showcase-title, .feature-showcase-description');
  
  if (!('IntersectionObserver' in window)) return;

  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  elements.forEach(element => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(30px)';
    element.style.transition = 'all 0.6s ease';
    animationObserver.observe(element);
  });
}

// Initialize scroll animations after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initScrollAnimations, 100);
});
